import $ from 'jquery';

function handleClick(event) {
  if ((this.href == null || this.href.indexOf('#') === -1) && this.href.startsWith(`${window.location.href}#`) === false && this.href.startsWith('/#') === false) {
    return;
  }

  const targetId = event.currentTarget.getAttribute('href').split('#')[1];
  const targetElement = document.getElementById(targetId);

  if (targetId === '') {
    event.preventDefault();

    $('html, body').animate({ scrollTop: 0 }, 500);

    return;
  }

  if (targetElement) {
    event.preventDefault();

    const navigationHeight = $('body > header').outerHeight();

    $('html, body').animate({ scrollTop: $(targetElement).offset().top - navigationHeight }, 500);
  }
}

export default function initializeSmoothScroll() {
  $('body').on('click', 'a', handleClick);
}
